import React from 'react';
import { Field, ErrorMessage } from 'formik';

export const StepSeven = () => {
  const options = [
    {
      value: 'none',
      label: 'None',
    },
    {
      value: 'DR',
      label: 'Race or ethnicity',
    },
    {
      value: 'DS',
      label: 'Sex/gender',
    },
    {
      value: 'DP',
      label: 'Pregnancy',
    },
    {
      value: 'DM',
      label: 'Maternity',
    },
    {
      value: 'DD',
      label: 'Physical or Mental health condition',
    },
    {
      value: 'DA',
      label: 'Age',
    },
    {
      value: 'DRn',
      label: 'Religious belief',
    },
    {
      value: 'DPl',
      label: 'Philosophical belief',
    },
    {
      value: 'DSy',
      label: 'Sexual orientation',
    },
    {
      value: 'DG',
      label: 'Gender reassignment',
    },
    {
      value: 'DMe',
      label: 'Marital or civil partnership status',
    },
  ];
  return (
    <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step">
      {/* <h6 className="text-lg font-bold mb-6">Discrimination issues</h6> */}

      <div className="mb-6 form-radio2-main">
        <p>
          <strong>Discrimination issues *</strong>
          <span>Select all that apply</span>
        </p>
        <div className="space-y-2">
          {options?.map((ele, i) => {
            return (
              <div className="flex items-center   form-check2" key={i}>
                <Field
                  type="checkbox"
                  name="other_issues"
                  value={ele?.value}
                  className="mr-2"
                  id={`otherIssues_${i}`}
                />
                <label htmlFor={`otherIssues_${i}`}>{ele?.label}</label>
              </div>
            );
          })}
          <ErrorMessage name="other_issues" component="div" className="required-text" />
        </div>
      </div>
    </div>
  );
};
